
import React, { useState, useEffect } from 'react';
import './Settings.css'; // Assuming you have a separate CSS file for styling
import Util from './Util'
import Swal from 'sweetalert2';

const Settings = ({auth, onLogout}) => {
  const [originalPassword, setOriginalPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);
  const [error,setError]= useState("");
  const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false); // State to toggle password visibility
  const [showOrigPassword, setShowOrigPassword] = useState(false); // State to toggle password visibility
  const [loadingAction, setLoadingAction] = useState(null);


  const fetchWithAuth = async (url, options = {}) => {
    const response = await fetch(url, {
      ...options,
      credentials: "include", // Send cookies/session
    });
  
    if (response.status === 401 || response.status === 403) {
      console.warn("JWT invalid or expired. Logging out...");
      onLogout(); // <-- your logout function
      throw new Error("Unauthorized");
    }
  
    return response;
  };
  


  // Scroll to the bottom of the chat box whenever messages change
  useEffect(() => {    
  }, []);
  
  
  // Handle password change submission
  const handlePasswordChange = (e) => {
    e.preventDefault();
    
    setError("");
    console.log('Changing password...', originalPassword, newPassword);

    let ut = Util.getInstance();
    if(!ut.isStrongPassword(newPassword))
    {
        let msg = 'password is not strong enough. Ensure length is greater than 8, atleast 1 lowercase, at least 1 uppercase, at least 1 digit and at least 1 special character';
        setError(msg);
        return;
    }    
        
    changePasswordFunc();
  };

  const changePasswordFunc = async () =>
  {
      setIsWaitingForResponse(true);    
       
      const command = Util.serverName + "/protected/changeOriginalPassword"; // Base API endpoint
      try {
        // Make the API call using POST method with a JSON body
  
        const response = await fetchWithAuth(command, {
          method: 'POST', // Use POST method
          headers: { 'Content-Type': 'application/json' }, // Specify JSON format
          body: JSON.stringify({originalPassword:originalPassword, newPassword:newPassword}), // JSON payload
          
        });
  
        const data = await response.json(); // Parse the JSON response
  
        if (!response.ok) {
          // Handle HTTP errors
          // console.log("Response: "+response.message);
          // console.log("ResponseData: "+data.message);
          // throw new Error(data.msg || 'Something went wrong');
  
          console.log("Response Error")
          setError("Response Error");
          setIsWaitingForResponse(false);
          return;
        }
  
        if (!data.status) {
          // Handle application-specific errors (e.g., if `status` is false)
          // setError(error.message);
          console.log("Response Error");
          setError("Unable to Change Password");
          setIsWaitingForResponse(false);
          return;
          // throw new Error(data.msg);
        }

        // clipMessages(updatedMessages);
        // clipMessages(updatedMessages);
        setIsWaitingForResponse(false);
        setIsPasswordChanged(true);
        console.log("success");
      } catch (error) {
        // Set the error message to be displayed to the user
        console.log("Error thrown");
        
      } 
      finally 
      {
        setIsWaitingForResponse(false);
      }        
  }


  // Handle deleting website
  const handleDeleteWebsite = async () => {
    const result = await Swal.fire({
      title: 'Delete website?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#d33'
    });
  
    if (result.isConfirmed) {
      console.log('Deleting website...');
      await execDeleteWebsite();
    }
  };

  const handleClearStorage = () =>
  {
    localStorage.setItem("draft","");
    localStorage.setItem("ait_local", "");
    localStorage.setItem("ait_filename","");
    localStorage.setItem("draft_name","");
    localStorage.setItem("clipBoard", "[]");
    localStorage.setItem("bezier", "[]");
    localStorage.setItem("pline", "[]");
    localStorage.setItem("controls","[]");
    

    window.location.reload();
  }


  /*
  const publishWebsite = async () =>
  {

      const command = Util.serverName + "/protected/publishWebsite"; // Base API endpoint
      const response = await fetchWithAuth(command, {
        method: 'POST', // Use POST method
        headers: { 'Content-Type': 'application/json' }, // Specify JSON format
        body: JSON.stringify({}), // JSON payload
        
      });

      const data = await response.json(); // Parse the JSON response

      if (!response.ok) {
        // Handle HTTP errors
        // console.log("Response: "+response.message);
        // console.log("ResponseData: "+data.message);
        // throw new Error(data.msg || 'Something went wrong');
        setError("Response Error");

        return;
      }

      if (!data.status) {
        // Handle application-specific errors (e.g., if `status` is false)
        // setError(error.message);
        console.log("Response Error");
        setError("Unable to Publish Website");
        return;
        // throw new Error(data.msg);
      }

      // clipMessages(updatedMessages);
      // clipMessages(updatedMessages);
      console.log("success");    
  }

  const unpublishWebsite = async () =>
  {

      const command = Util.serverName + "/protected/unpublishWebsite"; // Base API endpoint
      const response = await fetchWithAuth(command, {
        method: 'POST', // Use POST method
        headers: { 'Content-Type': 'application/json' }, // Specify JSON format
        body: JSON.stringify({}), // JSON payload
        
      });

      const data = await response.json(); // Parse the JSON response

      if (!response.ok) {
        // Handle HTTP errors
        // console.log("Response: "+response.message);
        // console.log("ResponseData: "+data.message);
        // throw new Error(data.msg || 'Something went wrong');
        setError("Response Error");

        return;
      }

      if (!data.status) {
        // Handle application-specific errors (e.g., if `status` is false)
        // setError(error.message);
        console.log("Response Error");
        setError("Unable to Publish Website");
        return;
        // throw new Error(data.msg);
      }

      // clipMessages(updatedMessages);
      // clipMessages(updatedMessages);
      console.log("success");    
  }
  */

  const execDeleteWebsite = async () =>
  {
    try {
      setError("");
      setLoadingAction("delete");

      const command = Util.serverName + "/protected/deleteWebsite"; // Base API endpoint
      const response = await fetchWithAuth(command, {
        method: 'POST', // Use POST method
        headers: { 'Content-Type': 'application/json' }, // Specify JSON format
        body: JSON.stringify({}), // JSON payload
        
      });

      const data = await response.json(); // Parse the JSON response

      if (!response.ok) {
        // Handle HTTP errors
        // console.log("Response: "+response.message);
        // console.log("ResponseData: "+data.message);
        // throw new Error(data.msg || 'Something went wrong');
        setError("Response Error");

        return;
      }

      if (!data.status) {
        // Handle application-specific errors (e.g., if `status` is false)
        // setError(error.message);
        console.log("Response Error");
        setError("Unable to Delete Website");
        return;
        // throw new Error(data.msg);
      }

      // clipMessages(updatedMessages);
      // clipMessages(updatedMessages);
      console.log("success");      
    } finally {
      setLoadingAction(null);
    }

  }
  
  /*
  const handlePublishWebsite = async () => 
  {
    
      try {
        setError("");
        setLoadingAction("publish");
    
        // Your existing code...
       await publishWebsite();
    
      } finally {
        setLoadingAction(null);
      }
  }


  const handleUnpublishWebsite = async () => {
    try {
      setError("");
      setLoadingAction("unpublish");
  
      // Your existing code...
     await unpublishWebsite();
  
    } finally {
      setLoadingAction(null);
    }
  }

  */

  async function downloadZip() {
    try {
      setLoadingAction("download");
  
      const command = Util.serverName + "/protected/downloadZip";
  
      const response = await fetchWithAuth(command);
  
      if (!response.ok) 
      {
        const errorData = await response.json();
              // alert("Please select a file first!");
        Swal.fire({
          title: 'Info',
          text: errorData.message,
          icon: 'info',
          confirmButtonText: 'OK',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,    
        });    

        // alert(errorData.message);
        return;
      }
  
      const blob = await response.blob();
  
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
  
      a.href = url;
      a.download = `${auth.user.webId}.zip`;
  
      document.body.appendChild(a);
      a.click();
  
      a.remove();
      window.URL.revokeObjectURL(url);
  
    } catch (err) {
      console.error("Download failed:", err);
      alert("Download failed");
    } finally {
      setLoadingAction(null);
    }
  }

  

  // Handle deleting website
  const handleDownloadWebsite = () => {
    console.log("Downloading Site");
    // Call this function when the user clicks a button
    downloadZip();
  };


  const eye = '\u{1F441}';  // Eye symbol using Unicode escape
  const crossedOutEye = '\u{1F648}';// '\u{1F6AB}\u{1F441}';  // Crossed-out eye symbol

  return (
    <div className="settings-container">
      <h1>Settings</h1>
      <form className="settings-form" onSubmit={handlePasswordChange}>
        {/* Password Change */}
        <div className="form-group password-field">
          <label htmlFor="originalPassword">Original Password</label>
          <input            
            type={showOrigPassword ? 'text' : 'password'}
            className="form-input"
            id="originalPassword"
            value={originalPassword}
            onChange={(e) => setOriginalPassword(e.target.value)}
            placeholder="Enter your current password"
            required
          />
          <button
              type="button"
              onClick={() => setShowOrigPassword(!showOrigPassword)}
              className="toggle-password-btn"
              aria-label={showOrigPassword ? 'Hide password' : 'Show password'}
            >
              {!showOrigPassword ? crossedOutEye : eye}
            </button>

        </div>
        <div className="form-group password-field">
          <label htmlFor="newPassword">New Password</label>
          <input            
            type={showNewPassword ? 'text' : 'password'}
            id="newPassword"
            className="form-input"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter your new password"
            required
          />
          <button
              type="button"
              onClick={() => setShowNewPassword(!showNewPassword)}
              className="toggle-password-btn"
              aria-label={showNewPassword ? 'Hide password' : 'Show password'}
            >
              {!showNewPassword ? crossedOutEye : eye}
            </button>
        </div>


        <button type="submit" className="submit-btn">
          Change Password
        </button>
        {error!="" && (<p style={{ color: 'red' }}>{error}</p>)}
        {isPasswordChanged && <p>Password changed successfully!</p>}
        {isWaitingForResponse && <div className="spinner"></div>}
      </form>
      {/*
      <div className="settings-actions">


        <button
          onClick={handlePublishWebsite}
          className="action-btn delete-web"
          disabled={loadingAction === "publish"}
        >
          {loadingAction === "publish" ? (
            <>
              <span className="spinner"></span>
              Publishing...
            </>
          ) : (
            "Publish Website"
          )}
        </button>

        <button
          onClick={handleUnpublishWebsite}
          className="action-btn"
          disabled={loadingAction === "unpublish"}
        >
          {loadingAction === "unpublish" ? (
            <>
              <span className="spinner"></span>
              Unpublishing...
            </>
          ) : (
            "Unpublish Website"
          )}
        </button>
      </div>
                        */}


      <div className="settings-actions">
        <button
            onClick={handleClearStorage}
            className="action-btn"
        >
            Clear Browser Storage
        </button>
      </div>

      <div className="settings-actions">

        <button
          onClick={handleDeleteWebsite}
          className="action-btn delete-web"
          disabled={loadingAction === "delete"}
        >
          {loadingAction === "delete" ? (
            <>
              <span className="spinner"></span>
              Deleting...
            </>
          ) : (
            "Delete Website"
          )}
        </button>

        <button
          onClick={handleDownloadWebsite}
          className="action-btn"
          disabled={loadingAction === "download"}
        >
          {loadingAction === "download" ? (
            <>
              <span className="spinner"></span>
              Downloading...
            </>
          ) : (
            "Download Website"
          )}
        </button>

      </div>

    </div>
  );
};

export default Settings;

